import React from 'react';
import { Tracker, TrackImpression } from '@udemy/event-tracking';
import { useI18n } from '@udemy/i18n';
import { CardMediaImage, CourseProductCard, CardTitle, RatingTag, Tag } from '@udemy/react-product-card-components';
import { formatNumber, formatToCmpctNumber } from '../utils';
import { AcademyPresented, AcademySelected } from './events';
import styles from "./in-demand-career.module.css";
export const InDemandCareerCard = ({
  academy,
  isUSMarketplace,
  uiRegion
}) => {
  var _academy$careerImg3, _academy$careerImg4;
  const {
    gettext,
    interpolate
  } = useI18n();
  // Preload images for better performance
  React.useEffect(() => {
    var _academy$careerImg, _academy$careerImg2;
    // Only preload if we're in the browser
    if (typeof window !== 'undefined' && ((_academy$careerImg = academy.careerImg) !== null && _academy$careerImg !== void 0 && _academy$careerImg.square || (_academy$careerImg2 = academy.careerImg) !== null && _academy$careerImg2 !== void 0 && _academy$careerImg2.wide)) {
      const imageUrl = academy.careerImg.square || academy.careerImg.wide || '';

      // Create a link element for preloading
      const link = document.createElement('link');
      link.rel = 'preload';
      link.as = 'image';
      link.href = imageUrl;

      // Only append if the link doesn't already exist
      if (!document.head.querySelector(`link[href="${imageUrl}"]`)) {
        document.head.appendChild(link);

        // Cleanup
        return () => {
          document.head.removeChild(link);
        };
      }
    }
  }, [academy.careerImg]);
  const trackView = () => {
    Tracker.publishEvent(new AcademyPresented({
      academySlug: academy.slug,
      uiRegion: uiRegion !== null && uiRegion !== void 0 ? uiRegion : 'in-demand-career-card'
    }));
  };
  const trackClick = () => {
    Tracker.publishEvent(new AcademySelected({
      academySlug: academy.slug,
      uiRegion: uiRegion !== null && uiRegion !== void 0 ? uiRegion : 'in-demand-career-card'
    }));
  };

  // Filter out null values from the tags array to avoid rendering empty tags
  const tags = [(academy === null || academy === void 0 ? void 0 : academy.avgRating) && academy.avgRating > 0 && /*#__PURE__*/React.createElement(RatingTag, {
    key: "tag-1",
    rating: Number(academy.avgRating.toFixed(1)) || 0
  }), (academy === null || academy === void 0 ? void 0 : academy.totalReviews) && academy.totalReviews > 0 && /*#__PURE__*/React.createElement(Tag, {
    key: "tag-2"
  }, interpolate(gettext('%(numReviews)s ratings'), {
    numReviews: formatToCmpctNumber(academy.totalReviews)
  }, true)), (academy === null || academy === void 0 ? void 0 : academy.totalContentHours) && academy.totalContentHours > 0 && /*#__PURE__*/React.createElement(Tag, {
    key: "tag-3"
  }, interpolate(gettext('%(totalHours)s total hours'), {
    totalHours: formatNumber(academy.totalContentHours)
  }, true))].filter(Boolean);
  const jobsAndSalaryElement = isUSMarketplace ? /*#__PURE__*/React.createElement("div", {
    className: styles.card__salary
  }, academy.career.avgSalary && /*#__PURE__*/React.createElement("span", null, interpolate(gettext('%(avgSalary)s average salary (US)'), {
    avgSalary: formatNumber(academy.career.avgSalary)
  }, true)), academy.career.numOpenRoles && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("span", null, "\xA0\xA0\u2022\xA0\xA0"), /*#__PURE__*/React.createElement("span", null, interpolate(gettext('%(numOpenRoles)s open roles (US)'), {
    numOpenRoles: formatNumber(academy.career.numOpenRoles)
  }, true)))) : null;
  return /*#__PURE__*/React.createElement(TrackImpression, {
    trackFunc: trackView,
    visibilityThreshold: 0.75
  }, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(CourseProductCard, {
    className: styles.card,
    authors: jobsAndSalaryElement,
    title: /*#__PURE__*/React.createElement(CardTitle, {
      headingLevel: "h3",
      renderLink: CardTitle.renderRouterLink({
        onClick: trackClick,
        to: `/career/${academy.slug}/`
      })
    }, academy.career.name),
    layout: "vertical",
    mediaSquare: ((_academy$careerImg3 = academy.careerImg) === null || _academy$careerImg3 === void 0 ? void 0 : _academy$careerImg3.square) && /*#__PURE__*/React.createElement(CardMediaImage, {
      layout: "square",
      src: academy.careerImg.square
    }),
    mediaWide: ((_academy$careerImg4 = academy.careerImg) === null || _academy$careerImg4 === void 0 ? void 0 : _academy$careerImg4.wide) && /*#__PURE__*/React.createElement(CardMediaImage, {
      layout: "wide",
      src: academy.careerImg.wide
    }),
    tags: tags
  })));
};
//# sourceMappingURL=in-demand-career-card.react-component.js.map